import { MyPermissionsDto } from "../models/dtos/MyPermissions.dto";
import axiosCustom from "../utils/axiosInstance";

const API_BASE_URL: string = "/me";

export const getMyPermissions = async (): Promise<MyPermissionsDto> => {
  const res = await axiosCustom.get<MyPermissionsDto>(`${API_BASE_URL}/permissions`);
  return res.data;
};
